module.exports = __webpack_public_path__ + "static/media/sta_logo.76674312.svg";